import { z } from 'zod';

export const PlatformTransformEntrypoint = z.enum([
  'greenhouse-test',
  'fixins-test',
  'sweetgreen-frontline',
  'sweetgreen-coaches',
  'tinuiti-admin',
  'le-demo-hr',
  'mock-data-generator',
  'acme-qualfit-hr',
]);

export type PlatformTransformEntrypoint = z.infer<
  typeof PlatformTransformEntrypoint
>;

export const PlatformTransformEntrypoints = Object.values(
  PlatformTransformEntrypoint.Values,
);
